import { createSelector } from 'reselect';

const _scopedState = (state) => state.entities.emailIntegrations;

const _getNotificationList = (state) => _scopedState(state).notificationList;

const _getNotificationListById = (state) => _getNotificationList(state).byId;
const getNotificationList = (state) => _.values(_getNotificationListById(state));

const getNotificationById = createSelector(
  [getNotificationList, (state, emailTemplateId) => emailTemplateId],
  (notifications, emailTemplateId) => notifications.byId[emailTemplateId]
);

const getEmailTemplatePicker = (state) => _scopedState(state).emailTemplatePicker;
const getEmailTemplateDesigner = (state) => _scopedState(state).emailTemplateDesigner;

// TODO: kill this with fire
const getRemoveNotificationMessage = (state) => _getNotificationList(state).removeNotificationMessage;

const showValidationMessage = (state) => !_scopedState(state).emailTemplateDesigner.isFormValid;
const formErrors = (state) => _scopedState(state).emailTemplateDesigner.formErrors;

export default {
  getNotificationList,
  getNotificationById,
  getEmailTemplatePicker,
  getEmailTemplateDesigner,
  getRemoveNotificationMessage,
  showValidationMessage,
  formErrors,
};
